<template>
  <input
    :type="type"
    :value="modelValue"
    class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500
      focus:border-blue-500 block w-full placeholder-gray-400 dark:bg-gray-700 dark:border-gray-600
      dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
    :class="[
      {
        'cursor-not-allowed': $attrs.disabled
      },
      INPUT_SIZES[size]
    ]"
    :pattern="pattern"
    @input="$emit('update:modelValue', $event.target.value)">
</template>

<script setup>
const INPUT_SIZES = {
  default: 'px-3 py-2 text-base',
  lg: 'px-3 py-4 text-lg',
  sm: 'px-3 py-1.5 text-sm'
}

defineProps({
  type: {
    type: String,
    required: false,
    default: 'text',
    validator: (prop) => ['text', 'number', 'search', 'password', 'phone', 'email', 'url', 'date', 'time'].includes(prop)
  },
  modelValue: {
    required: true,
    validator: (prop) => typeof prop === 'string' || typeof prop === 'number' || prop === null || prop === undefined
  },
  size: {
    type: String,
    required: false,
    default: 'default',
    validator: (prop) => ['default', 'lg', 'sm'].includes(prop)
  },
  pattern: {
    type: String,
    default: '.*'
  }
})

defineEmits(['update:modelValue'])
</script>
